import React from 'react'

import useTextContents from '../../hooks/useTextContents'
import {
   useGetManualVerificationContentBasedOnBackendData,
   useGetManualVerificationContentDetailsBasedOnBackendData
} from './hooks/useGetManualVerificationContentBasedOnBackendData'
import Paragraph from '../../components/atoms/Paragraph/Paragraph'
import PageScreen from '../../components/organisms/Page/PageScreen'
import { APP_COLOR, APP_FONT_SIZE } from '../../components/atoms/AtomsGlobalProps'
import LoanOfferSummaryPanel from '../../components/organisms/LoanOfferSummaryPanel/LoanOfferSummaryPanel'

import {ReactComponent as ManualVerificationIcon} from '../../icons/svg/manual-verification-page-icon.svg'
import './ManualVerificationPage.scss'


const ManualVerificationPageHubRedirection = () => {
   const textContent = useTextContents()
   const manualVerificationContentBasedOnBackend = useGetManualVerificationContentBasedOnBackendData()
   const manualVerificationContentDetailsBasedOnBackend = useGetManualVerificationContentDetailsBasedOnBackendData()


   return (
      <PageScreen
         title={{title: textContent('manualVerificationPage.heading'), line: true}}
         icon={{ icon: ManualVerificationIcon, decorative: true, color: 'var(--color-primary-600)' }}
         panel={<LoanOfferSummaryPanel readOnly={true} loanVariant='selectedOffer' />}
      >
         <div className='manual-verification-description'>
            <Paragraph html={ manualVerificationContentBasedOnBackend } />
            <Paragraph html={ manualVerificationContentDetailsBasedOnBackend } />
         </div>
         <Paragraph size={APP_FONT_SIZE.SMALL} color={APP_COLOR.GRAY} align={"center"}>
            {textContent('manualVerificationPage.tip')}
         </Paragraph>
      </PageScreen>
   )
}

export default ManualVerificationPageHubRedirection